import { FirebaseError } from 'firebase/app'

const EXPECTED_AUTH_ERROR_CODES = [
  'auth/expired-action-code',
  'auth/invalid-action-code',
]

export const isExpectedAuthError = (error: unknown): boolean => {
  return (
    error instanceof FirebaseError &&
    EXPECTED_AUTH_ERROR_CODES.includes(error.code)
  )
}
